import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';
import { ENVIRONMENT } from '../../environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TrackJS } from 'trackjs';

TrackJS.install(ENVIRONMENT.TrackJS);

enableProdMode();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    registerServiceWorker('sw')
  });

function registerServiceWorker(swName: string) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register(`/${swName}.js`)
      .then(reg => {
        console.log('[App] Successful service worker registration', reg);
      })
      .catch(err =>
        console.error('[App] Service worker registration failed', err)
      );
  } else {
    console.error('[App] Service Worker API is not supported in current browser');
  }
}



// WEBPACK FOOTER //
// ./src/app/main.ts